import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectEnhancedLeagues } from '../reducers/enhanced_leagues'
import { getAvailableConfigOptions } from '../reducers/leagues_configs'

const useAvailableConfigOptions = () => {
  const enhancedLeagues = useSelector(selectEnhancedLeagues) || []
  return useMemo(() => getAvailableConfigOptions(enhancedLeagues), [ enhancedLeagues ])
}

export default useAvailableConfigOptions
